import { isString } from './assertions';

export function getIfString<T>(str: unknown, defaultValue: T) {
  if (isString(str)) {
    return str.trim();
  }

  return defaultValue;
}

export function normalizeString(inputString: unknown) {
  if (!isString(inputString)) return '';

  // remove all accents and weird characters from string
  let cleanString = inputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  cleanString = cleanString.replace(/[^a-zA-Z0-9\s]/g, '');
  // el regex anterior limpia todos los characteres que no sean alfanumericos o espacios, si nos quedamos con una string vacia simplemente volvemos a la string original
  if (cleanString === '') return inputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return cleanString;
}

export function camelCaseToRegularString(inputString: string) {
  let regularString = inputString.replace(/([a-z])([A-Z])/g, '$1 $2');
  regularString = regularString.toLowerCase().trim();
  return regularString;
}

export function interpolate(str: string, obj: Record<string, string>) {
  if (typeof str !== 'string') {
    return '';
  }
  let copy = str;
  Object.entries(obj).forEach(([key, value]) => {
    // TODO: replace with replaceAll after nodeJs upgrade
    // use regex to replace all instances of key with value
    copy = copy.replace(new RegExp(key, 'g'), value ?? '');
  });
  return copy;
}

// help for removing diacriticals https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript?page=1&tab=scoredesc#tab-top
export function removeStrangeCharacters(inputString: unknown) {
  if (!isString(inputString)) return '';
  // remove all accents and weird characters from string
  return inputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  // return inputString.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

const fakeBase = 'https://fake.url.com';

export function normalizeUrl(s: unknown, { removeQuery = true } = {}) {
  if (!isString(s)) return '';
  const url = new URL(s, fakeBase);
  let { pathname } = url;

  // decodeURIComponent

  pathname = pathname
    .trim()
    .split('/')
    .filter(Boolean)
    .map((part) => {
      if (part.match(/([a-z]{2}_[A-Z]{2})/g)) {
        return part;
      }
      part = decodeURIComponent(part);
      part = removeStrangeCharacters(part);
      part = part.replace(/\s+/g, '_');
      return part;
    })
    .join('/');
  return url.origin === fakeBase ? `/${pathname}${removeQuery ? '' : url.search}` : `${url.origin}/${pathname}${removeQuery ? '' : url.search}`;
}

export function hasNonAlphaCharacters(string: unknown) {
  if (!isString(string)) return false;
  return /[^a-zA-Z]/g.test(string);
}

export function capitalizeFirstLetters(string: unknown) {
  if (!isString(string)) return '';
  return string.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
}

export function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function splitWithSeparators(input: unknown, separators: string[], endTag = /<\/TAG>/): string[] {
  // first we handle non string inputs and return an empty array
  if (!isString(input)) return []; // Return an empty array if the input is not a string.

  // remove all endTags from the string
  const endTagRegex = new RegExp(endTag, 'g');
  const inputWithoutTagEnds = input.replace(endTagRegex, '').trim();

  // handle empty input string
  if (inputWithoutTagEnds === '') return [];

  // handle empty separator array
  if (separators.length === 0) {
    console.log({ inputWithoutTagEnds });
    return [inputWithoutTagEnds];
  }

  // then we need to find for each separator the indexes in the input where the separator is found
  const indexes: [number, number][] = [];
  separators.forEach((separator) => {
    const regex = new RegExp(separator, 'g');
    const matches = [...inputWithoutTagEnds.matchAll(regex)];
    indexes.push(...matches.map((match) => [match.index, match.index + separator.length] as [number, number]));
  });

  // handle empty indexes array
  if (indexes.length === 0) {
    return [inputWithoutTagEnds];
  }
  // then we need to sort the indexes by start index
  indexes.sort((a, b) => a[0] - b[0]);
  // then given the start, and end of the indexes we can slice the input string and return the result
  const result: string[] = [];
  let lastIndex = 0;
  indexes.forEach(([start, end], index, array) => {
    const isLast = index === array.length - 1;
    if (lastIndex < start) {
      result.push(inputWithoutTagEnds.slice(lastIndex, start));
    }
    result.push(inputWithoutTagEnds.slice(start, end));
    if (isLast && end < inputWithoutTagEnds.length) {
      result.push(inputWithoutTagEnds.slice(end));
    }

    lastIndex = end;
  });
  return result;
}
